// removed by extract-text-webpack-plugin
module.exports = {"col2":"_1zJg","centerOnMobile":"_2tec"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col2TextPicture/Col2TextPicture.scss
// module id = kcDk
// module chunks = 0